import React from "react";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";

const ViewTestDetails = ({ viewTestDetails, setViewTestDetails, clinicTestMasterTestInfo, handleViewTestDetailsModal, handleDeleteTest, handleEditTestDetails }) => {

    return (
        <>
            <Modal
                show={viewTestDetails}
                onHide={() => handleViewTestDetailsModal()}
                size={"xl"}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {clinicTestMasterTestInfo?.testName} Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <div className="staf-info">
                                                <h4 className="mb-3">{clinicTestMasterTestInfo?.testName}</h4>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">Category</span>
                                                <span>{clinicTestMasterTestInfo?.category?.categoryName || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">Department</span>
                                                <span>{clinicTestMasterTestInfo?.department || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">Reference Range</span>
                                                <span>{clinicTestMasterTestInfo?.reference_range_details || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">Units</span>
                                                <span>{clinicTestMasterTestInfo?.units || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">Status</span>
                                                <span>{clinicTestMasterTestInfo?.status || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">Low Range</span>
                                                <span>{clinicTestMasterTestInfo?.low_range || "N/A"}</span>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">High Range</span>
                                                <span>{clinicTestMasterTestInfo?.high_range || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">M Low Range</span>
                                                <span>{clinicTestMasterTestInfo?.mlow_range || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">M High Range</span>
                                                <span>{clinicTestMasterTestInfo?.mhigh_range || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">F Low Range</span>
                                                <span>{clinicTestMasterTestInfo?.flow_range || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">F High Range</span>
                                                <span>{clinicTestMasterTestInfo?.fhigh_range || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">I low Range</span>
                                                <span>{clinicTestMasterTestInfo?.ilow_range || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">I High Range</span>
                                                <span>{clinicTestMasterTestInfo?.ihigh_range || "N/A"}</span>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">TAX</span>
                                                <span>{clinicTestMasterTestInfo?.tax || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">TAT</span>
                                                <span>{clinicTestMasterTestInfo?.tat || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">Test Id</span>
                                                <span>{clinicTestMasterTestInfo?.testid || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">Patient Price</span>
                                                <span>{clinicTestMasterTestInfo?.pt_price || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">Client Price</span>
                                                <span>{clinicTestMasterTestInfo?.client_price || "N/A"}</span>
                                            </div>
                                            <div className="d-flex justify-content-between border-bottom mb-3">
                                                <span className="font-w600 text-black">LIS Code</span>
                                                <span>{clinicTestMasterTestInfo?.lisCode?.codeName || "N/A"}</span>
                                            </div>
                                            <div className="mt-4 d-flex justify-content-end gap-3 mt-5">
                                                <button className="btn btn-danger" onClick={() => handleDeleteTest(clinicTestMasterTestInfo?._id)}>Delete</button>
                                                <Link to={"#"} className="btn btn-primary" onClick={() => handleEditTestDetails(clinicTestMasterTestInfo)}>Edit</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ViewTestDetails;